import { api } from "./api";


export const googleLoginApi = (params) => {
    return api.post(`/auth/google-login`, JSON.stringify(params));
};

export const microsoftLoginApi = (params) => {
    return api.post(`/auth/microsoft-login`, JSON.stringify(params));
};

export const emailLoginApi = (params) => {
    return api.post(`/auth/login`, JSON.stringify(params));
};

export const forgotPasswordApi = (params) => {
    return api.post(`/auth/forgot-password`, JSON.stringify(params));
};

export const resetPasswordApi = (params) => {
    return api.post(`/auth/reset-password`, JSON.stringify(params));
};

export const verifyTokenApi = (params) => {
    return api.post(`/auth/verify-token`, JSON.stringify(params));
};